import { render, staticRenderFns } from "./ModalPaymentConfirmation.vue?vue&type=template&id=f99fa964&"
import script from "./ModalPaymentConfirmation.vue?vue&type=script&lang=js&"
export * from "./ModalPaymentConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports